import React from 'react';
import PropTypes from 'prop-types';
import './index.scss';

/*
 * Type definitions
 */
const propTypes = {
    children: PropTypes.node,
    url: PropTypes.string.isRequired,
    label: PropTypes.string,
};

const defaultProps = {
    children: null,
    label: 'Yes please ! !',
};

/*
 * Component
 */
function LinkBox({ children, url, label }) {
    if (!url) {
        return null;
    }

    return (
        <div className="link-box">
            <div className="content-wrapper">
                {children}
                <a
                    href={url}
                    className="button"
                >
                    {label}
                </a>
            </div>
        </div>
    );
}

LinkBox.propTypes = propTypes;
LinkBox.defaultProps = defaultProps;

export default LinkBox;
